import { ParamType } from "@/types/Others";
import ApiUrls from "../ApiUrl";
import BaseService from "../Base";

class WhatsappMessageService extends BaseService {
  async getWhatsappMessageList(params: ParamType) {
    try {
      const response = await this.post(`${ApiUrls.whatsappDirectMessage}/list`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async sendWelcomeMessage(payload: { mobile: string; fullName: string } | { mobile: string; fullName: string }[]) {
    try {
      const response = await this.post(`${ApiUrls.whatsappDirectMessage}/send-welcome-message`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const whatsappMessageService = new WhatsappMessageService();
